import { isLoggedInCheck } from "../lib/functions";
import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
	let auth = isLoggedInCheck();
	return auth ? children : <Navigate to="/login" />;
}
